import { CONFIG } from '../config';
import { USER_API_URL } from '../constants';
import { ERROR_MESSAGES } from './authenticate';
import { OtpCodeResponse } from './sendOTPCode';

export const verifyOTPCode = async (
  userId: string,
  email: string,
  accessToken: string,
  code: string
) => {
  const response = await fetch(`${USER_API_URL}/v2/verify_email_otp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/vnd.api+json',
      authorization: accessToken ? `Bearer ${accessToken}` : '',
      'X-Bypass-Rack-Attack': CONFIG.BYPASS_RACK_ATTACK
    },
    body: JSON.stringify({
      data: {
        id: userId,
        type: 'user',
        code,
        attributes: {
          email
        }
      }
    })
  });

  const data: OtpCodeResponse = await response.json();
  if (data.message == null) {
    throw new Error(ERROR_MESSAGES.default);
  }
  return data.message;
};
